// extracted by mini-css-extract-plugin
export default {"title":"UserBlockTab_title__umIMS"};